<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :ordenar-nomes="[
        'Número',
        'Paciente',
        'Solicitante',
        'Convênio',
        'Data',
        'Unidade',
      ]"
      :ordenar-por="[
        'autorizacao.numeroGuia',
        'beneficiario.nome',
        'contratadoSolicitante.profissionalSolicitante.nome',
        'beneficiario.convenio.nome',
        'autorizacao.dataEmissao',
        'unidade.nome',
      ]"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
            <CampoGenerico
              id="numero"
              label="Número da Guia"
              mascara="99999999999999999999"
              :valor="filtro.numero"
              @atualizar="filtro.numero = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
            <SelecionarConvenio
              :valor="filtro.convenio"
              @atualizar="filtro.convenio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <BuscarSelecionarPaciente
              :minimo="1"
              label="Paciente / Beneficiário"
              @selecionadoPaciente="filtro.pacienteId = $event._id"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <BuscarSelecionarMedico
              :minimo="1"
              label="Profissional Solicitante"
              @selecionadoMedico="filtro.profissionalSolicitante = $event._id"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <SelecionarUnidade
              :valor="filtro.unidade"
              @atualizar="filtro.unidade = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarEspecialidade
              :valor="filtro.especialidade"
              @atualizar="filtro.especialidade = $event"
            />
          </div>
          <div class="form-group col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataInicio"
              label="Data Início"
              :valor="filtro.dataInicio"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataFim"
              label="Data Fim"
              :valor="filtro.dataFim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><GuiaTabela
          :guias="guias"
          @guiaDeletada="remover"
          @guiaEnviadaParaFaturamento="enviarParaFaturamento"
          @guiaRemovidaDoFaturamento="removerDoFaturamento"
          @exportarGuia="exportarGuia"
          @guiaPagamentoBloqueado="bloquearPagamento"
          @guiaPagamentoDesbloqueado="desbloquearPagamento"
          @gerarGuiaConsulta="exportarGuiaConsulta"
      /></template>
      <template #fichas>
        <div
          v-for="guia in guias"
          :key="guia._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <GuiaFicha
            :guia="guia"
            @guiaDeletada="remover"
            @guiaEnviadaParaFaturamento="enviarParaFaturamento"
            @guiaRemovidaDoFaturamento="removerDoFaturamento"
            @exportarGuia="exportarGuia"
            @guiaPagamentoBloqueado="bloquearPagamento"
            @guiaPagamentoDesbloqueado="desbloquearPagamento"
            @gerarGuiaConsulta="exportarGuiaConsulta"
          />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import BuscarSelecionarMedico from '@/componentes/formulario/BuscarSelecionarMedico'
import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import SelecionarConvenio from '@/componentes/formulario/SelecionarConvenio'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import GuiaServico from '@/servicos/GuiaServico'

import GuiaFicha from './GuiaFicha'
import GuiaTabela from './GuiaTabela'

export default {
  name: 'GuiaConsulta',
  components: {
    GuiaFicha,
    GuiaTabela,
    BlocoFiltroPesquisa,
    CampoGenerico,
    SelecionarConvenio,
    BuscarSelecionarPaciente,
    BuscarSelecionarMedico,
    SelecionarUnidade,
    SelecionarEspecialidade,
    SelecionarSituacao,
    SelecionarData,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const solicitantes = ref([])
    const guias = ref([])
    const servico = new GuiaServico()
    const nomeResultado = 'guias'
    const nomeDoForm = 'GuiaForm'
    const filtro = ref({
      numero: '',
      pacienteId: '',
      dataInicio: '',
      dataFim: '',
      convenio: '',
      profissionalSolicitante: '',
      unidade: '',
      especialidade: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: guias,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(21)
    return {
      solicitantes,
      guias,
      servico,
      filtro,
      ...pesquisa,
    }
  },

  methods: {
    remover(guiaId) {
      this.servico.remover(guiaId).then((res) => {
        this.pesquisar(this.filtro.skip)
      })
    },
    enviarParaFaturamento(guiaId) {
      this.$prompt({
        content: 'Observação',
      }).then((obs) => {
        this.servico.enviarParaFaturamento(guiaId, obs).then((res) => {
          this.pesquisar(this.filtro.skip)
        })
      })
    },
    removerDoFaturamento(guiaId) {
      this.servico.removerDoFaturamento(guiaId).then((res) => {
        this.pesquisar(this.filtro.skip)
      })
    },
    bloquearPagamento(guiaId) {
      this.servico.bloquearPagamento(guiaId).then((res) => {
        this.pesquisar(this.filtro.skip)
      })
    },
    desbloquearPagamento(guiaId) {
      this.servico.desbloquearPagamento(guiaId).then((res) => {
        this.pesquisar(this.filtro.skip)
      })
    },
    exportarGuia(guiaId) {
      this.servico.exportarGuia(guiaId).then((r) => {
        const blob = new Blob([r], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      })
    },
    exportarGuiaConsulta(guiaId) {
      this.servico.exportarGuia(guiaId, 'consulta').then((r) => {
        const blob = new Blob([r], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      })
    },
  },
}
</script>
